import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface CertificateNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (firstName: string, lastName: string) => void;
  firstName?: string;
  lastName?: string;
  hasCertificateName?: boolean;
}

export function CertificateNameModal({
  isOpen,
  onClose,
  onSave,
  firstName: initialFirstName = "",
  lastName: initialLastName = "",
  hasCertificateName = false,
}: CertificateNameModalProps) {
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);

  useEffect(() => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
  }, [initialFirstName, initialLastName, isOpen]);

  const handleSave = () => {
    onSave(firstName, lastName);
  };

  const handleClose = () => {
    setFirstName("");
    setLastName("");
    onClose();
  };

  const modalTitle = hasCertificateName ? "Edit Your Name" : "Add Your Name";

  return (
    <Dialog
      header={modalTitle}
      visible={isOpen}
      onHide={handleClose}
      modal
      style={{ width: "400px" }}
      data-testid="certificate-name-modal"
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label htmlFor="cert-first-name" className="body-sm">
            First Name
          </label>
          <InputText
            id="cert-first-name"
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            placeholder="Enter first name"
            data-testid="certificate-name-first-input"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label htmlFor="cert-last-name" className="body-sm">
            Last Name
          </label>
          <InputText
            id="cert-last-name"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            placeholder="Enter last name"
            data-testid="certificate-name-last-input"
          />
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <Button
            label="Cancel"
            severity="secondary"
            onClick={handleClose}
            data-testid="certificate-name-cancel-button"
          />
          <Button label="Save" onClick={handleSave} data-testid="certificate-name-save-button" />
        </div>
      </div>
    </Dialog>
  );
}
